module.exports = __webpack_public_path__ + "img/icon_img50.32844708.png";